import { tableStyle } from "./constants";
import { classNames } from "tools/ui";

const _style = classNames(
  "calendar-category-row",
  "text-xs text-center text-gray-100",
  tableStyle.categoryStyle,
);

function CategoryRow({ idx, data, prices }) {
  const { categoryStyle } = tableStyle;
  const prices_by_acco = prices[data.accoId];
  const categoryCell = prices_by_acco.map((price, index) => {
    // const datefmt = date.format(day, fmtDate);
    let value = "---";
    if (price) {
      value = Math.floor(price / 1000);
      // const prices_by_acco = prices[datefmt];
      // const price = prices_by_acco[data.accoId];
    }

    return (
      <td key={index} className={_style}>
        {value}
      </td>
    );
  });

  return (
    <tr key={idx} className={classNames(categoryStyle)}>
      <td key={data.accoName} className="rack-room-col rack-acco-col">
        <span className="pl-3 text-sm text-zinc-100 font-bold truncate">
          {data.accoName}
        </span>
      </td>
      {categoryCell}
    </tr>
  );
}

export default CategoryRow;
